// return difference in percentages %
export default function calcDifference(current: number, last: number) {
  return  last === 0
    ? current === 0 ? 0 : 100
    : ((current - last) / last) * 100;
}